import * as Actions from '../actions';

const initialState = {
    allQualifications: [],
    selectedQualification: {
        qualification_id: 0,
        QualificationName: '',
        QualificationDescription: '',
        QualificationText: '',
        RequireAsset: 0
    }
}

const companyQualificationReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_QUALIFICATION_FORM):
            {
                return {
                    ...state,
                    selectedQualification: { ...state.selectedQualification, ...action.payload }
                }
            }
        default:
            {
                return state;
            }
    }
}

export default companyQualificationReducer;


// WEBPACK FOOTER //
// src/main/content/company/store/reducers/company.qualifications.reducer.js